var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePasswordManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 192 192",
    height: "24px",
    viewBox: "0 0 192 192",
    width: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 192,
    width: 192,
    y: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.29,106c-3.46,5.97-9.91,10-17.29,10c-11.03,0-20-8.97-20-20s8.97-20,20-20 c7.38,0,13.83,4.03,17.29,10h25.55C90.3,66.54,72.82,52,52,52C27.74,52,8,71.74,8,96s19.74,44,44,44c20.82,0,38.3-14.54,42.84-34 H69.29z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FBBC04",
    height: 24,
    width: 44,
    x: 94,
    y: 84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.32,84H68v0.05c2.5,3.34,4,7.47,4,11.95s-1.5,8.61-4,11.95V108h26.32 c1.08-3.82,1.68-7.84,1.68-12S95.41,87.82,94.32,84z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,106v26h-16v-8c0-4.42-3.58-8-8-8s-8,3.58-8,8v8h-16v-26H184z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#188038",
    height: 24,
    width: 48,
    x: 136,
    y: 84
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePasswordManager);
export default __webpack_public_path__ + "static/media/GooglePasswordManager.f83bce240fb823f5c3f3e39e58450da8.svg";
export { ForwardRef as ReactComponent };